import { Button, Card, Empty, Flex, Typography } from "antd";
import React, { useEffect, useState } from "react";
import FileUpload from "../../components/UploadComp/FileUpload/FileUpload";
import "./UploadPage.scss";
import Selector from "../../components/UploadComp/Selector/Selector";
import OrangeBtn from "../../Reuseable/OrangeBtn/OrangeBtn";
import TableWithChart from "../../Reuseable/TableWithChart/TableWithChart";
import HalfDonutPieChart from "../../Reuseable/HalfDonutPieChart/HalfDonutPieChart";
import morevert from "../../assets/Icons/morevert.svg";
import AddTrustModal from "../../components/UploadComp/AddTrustModal/AddTrustModal";
import { setList, uploadLoanFile } from "../../store/uploadSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserTrusts } from "../../store/trusts";
import noDataGif from "../../assets/gif/no-data.gif";
import { uploadFile } from "../../api/Upload";
import toast from "react-hot-toast";
import {ReactComponent as PlusIcon} from "../../assets/Icons/plusIcon.svg"
import NormalButton from "../../Reuseable/NormalButton/NormalButton";

const UploadPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [file, setFile] = useState(null);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);
  const { trust_list, trust_loading } = useSelector((state) => state.trust);
  const { token } = useSelector((state) => state.auth);
  const [selectedTrust, setSelectedTrust] = useState("Select Trust");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { Text } = Typography;

  useEffect(() => {
    dispatch(fetchUserTrusts());
  }, []);

  const options =
    Array.isArray(trust_list) &&
    trust_list?.map((trust) => ({
      value: trust?.trustname,
      label: trust?.trustname,
    }));
  const handleUpload = async () => {
    try {
      setLoading(true);

      const response = await uploadFile(token, {
        file,
        trust_name: selectedTrust,
        file_password: "rarc",
      });

      if (response?.status === "success") {
        toast?.success(response.message);
        dispatch(fetchUserTrusts());
        setSelectedTrust("Select Trust");
        setFile(null);
      } else {
        toast?.error(response?.message || "Upload failed. Please try again.");
      }
    } catch (error) {
      toast?.error("Something went wrong. Please try again.");
    
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="main_wrapper_for_uploadpage">
      <Card className="upload_section">
        <Text className="file_upload_label title_">Upload a file</Text>
        <div className="content_wrapped">
          <Flex className="fileUploadSection">
            <FileUpload setFile={setFile} file={file} />
            {/* <input type="file" onChange={(e)=>setFile(e.target.files[0])} name="" id="" /> */}
          </Flex>
          <Flex className="selectorBox_wrapper">
            <Selector
              options={options}
              setValue={setSelectedTrust}
              value={selectedTrust}
            />
          </Flex>
        </div>
        <Flex className="uploadBtnWrapper">
          <OrangeBtn
            loading={loading}
            text="Upload"
            onClick={handleUpload}
            disable={
              selectedTrust === "Select Trust" ||
              selectedTrust === null ||
              file === null
            }
          />
        </Flex>
      </Card>

      <Card className="trustList_section">
        <Flex className="title_trustlist">
          <Text className="title_text">Trust List</Text>
          <NormalButton onClick={showModal} text="Add New Trust" prefixIcon={<PlusIcon/>}/>
        </Flex>
        <Flex className="table_section">
          {trust_list?.length > 0 ? (
            <TableWithChart
              data={trust_list?.map((item, index) => ({
                ...item,
                key: index + 1,
              }))}
              scroll={{}}
              loading={trust_loading}
            />
          ) : (
            <Flex justify="center" style={{ width: "100%", height: "100%" }}>
              <Empty description="No Trust Found" />
            </Flex>
          )}
        </Flex>
      </Card>

      <AddTrustModal open={isModalVisible} onCancel={handleCancel} />
    </Card>
  );
};

export default UploadPage;
